// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import { keepaliveEmitter } from './context';

export function dropByCacheKey(path: string) {
  keepaliveEmitter.emit({type:'dropByCacheKey', payload: {
    path
  }});
}
export function refreshTab(path: string) {
  keepaliveEmitter.emit({type:'refreshTab', payload: {
    path
  }});
}
export function closeTab(path: string) {
  keepaliveEmitter.emit({type:'closeTab', payload: {
    path
  }});
}
export function closeAllTabs() {
  keepaliveEmitter.emit({type:'closeAllTabs'});
}
/**
 * NOTE 新增一个替换路径的方法， 将指定路径替换成新路径，且保持原 tab 位置
 * @param path1 路径 1，可跳转的路径，必填
 * @param path2 路径 2，可选。
 *     - 如果不传，则对当前 tab 的路径进行替换，替换为 path 1
 *     - 如果传入，则将 path 1 tab 替换为 path 2，且保持原 tab 的位置
 * @param isStayCurrentTab 是否保持在当前 tab 不跳转，默认 false，替换后会跳转到新的 tab
 */
export function replaceTab(path1: string, path2?: string, isStayCurrentTab: boolean = false) {
  keepaliveEmitter.emit({
    type: 'replaceTab',
    payload: { path1, path2, isStayCurrentTab }
  });
}
/**
 * NOTE 根据路由的路径选择器去匹配替换的路径
 * @param path
 * @param myRouter
 * @param isStayCurrentTab 是否保持在当前 tab 不跳转，默认 false，替换后会跳转到新的 tab
 */
export function replaceTabByRouter(path: string, myRouter?: string, isStayCurrentTab: boolean = false) {
  keepaliveEmitter.emit({
    type: 'replaceTabByRouter',
    payload: { path, myRouter, isStayCurrentTab }
  });
}
/**
 * NOTE 将两个指定路径的 tab 互换位置
 * @param path1 的 Tab 路径
 * @param path2 的 Tab 路径
 */
export function swapTab(path1: string, path2: string) {
  keepaliveEmitter.emit({
    type: 'swapTab',
    payload: { path1, path2 }
  });
}
/**
 * NOTE 将指定路径的 tab 移动到目标路径前面或者后面（自动检测，待移动的 tab 位置大于目标位置时，说明往前移动，反之是往后移动）
 * @param sourcePath 待移动的 tab 路径
 * @param targetPath 目标 tab 路径
 */
export function moveTab(sourcePath: string, targetPath: string) {
  keepaliveEmitter.emit({
    type: 'moveTab',
    payload: { sourcePath, targetPath }
  });
}
/**
 * NOTE 将指定路径的 tab 移动到目标路径之前
 * @param sourcePath 待移动的 tab 路径
 * @param targetPath 目标 tab 路径
 */
export function moveBeforeTab(sourcePath: string, targetPath: string) {
  keepaliveEmitter.emit({
    type: 'moveBeforeTab',
    payload: { sourcePath, targetPath }
  });
}
/**
 * NOTE 将指定路径的 tab 移动到目标路径之后
 * @param sourcePath 待移动的 tab 路径
 * @param targetPath 目标 tab 路径
 */
export function moveAfterTab(sourcePath: string, targetPath: string) {
  keepaliveEmitter.emit({
    type: 'moveAfterTab',
    payload: { sourcePath, targetPath }
  });
}
/**
 * NOTE 获取当前所有缓存的 tab 的路径
 */
export function getTabList() {
  if (window.__keepalive_tabs_list__) {
      return window.__keepalive_tabs_list__;
  }

  if (window.sessionStorage.getItem('__keepalive_tabs_list__')) {
      return JSON.parse(window.sessionStorage.getItem('__keepalive_tabs_list__'));
  }

  if (window.localStorage.getItem('__keepalive_tabs_list__')) {
      return JSON.parse(window.localStorage.getItem('__keepalive_tabs_list__'));
  }

  return [];
}

export function addPlaceholderTab(path: string, index?: number) {
  keepaliveEmitter.emit({
    type: 'addPlaceholderTab',
    payload: { path, index }
  });
}

/**
 * NOTE 触发关闭之前的事件
 * @param event
 */
export function triggerCloseBorEvent(e) {
    // 卸载之前先转移焦点，从而让页面被卸载时，不会因为引用问题导致页面泄漏
    e?.preventDefault?.();
    e?.stopPropagation?.();
    e?.nativeEvent?.stopImmediatePropagation?.();
    document.activeElement?.blur();
    document.getElementById('fixed-global-focus-input')?.focus();
    document.getElementById('fixed-global-focus-input')?.click();
}
